var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 10.7493V14.2493C13.3337 17.166 12.167 18.3327 9.25033 18.3327H5.75033C2.83366 18.3327 1.66699 17.166 1.66699 14.2493V10.7493C1.66699 7.83268 2.83366 6.66602 5.75033 6.66602H9.25033C12.167 6.66602 13.3337 7.83268 13.3337 10.7493Z",
    stroke: "#292D32",
    strokeWidth: 1.21154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 5.7513V9.2513C18.3337 12.168 17.167 13.3346 14.2503 13.3346H13.3337V10.7513C13.3337 7.83464 12.167 6.66797 9.25033 6.66797H6.66699V5.7513C6.66699 2.83464 7.83366 1.66797 10.7503 1.66797H14.2503C17.167 1.66797 18.3337 2.83464 18.3337 5.7513Z",
    stroke: "#292D32",
    strokeWidth: 1.21154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fe832b273f73ad4457be16369e48d19b.svg";
export { ForwardRef as ReactComponent };